import './OnboardingPages.scss';

import React, {useEffect, useState} from 'react';
import {Alert, Button, Col, Container, Row, Spinner} from "react-bootstrap";
import HandicaddieLogo from "../../../icons/HandicaddieLogo";
import Form from "react-bootstrap/Form";
import {Formik} from "formik";
import {useNavigate} from "react-router-dom";
import * as yup from "yup";
import {CredentialsService} from "../../../services/api/CredientialsService";
import ErrorText from "../../../components/ErrorText";
import {FORGOT_PASSWORD_RESET} from "../../../services/PageUtils";

interface Props {

}

const ForgotPasswordEmailConfirmation = ({}: Props) => {

    const navigate = useNavigate();
    const { deleteCredentials } = CredentialsService();

    const [errMsg, setErrMsg] = useState<string>();
    const [loading, setLoading] = useState<boolean>(false);

    const schema = yup.object().shape({
        email: yup.string().email().required("Email is required")
    });

    useEffect(() => {
        setLoading(false);
    }, []);

    const submitForm = async (values: any) => {
        setLoading(true);
        setErrMsg(undefined)
        let resp = await deleteCredentials(values.email);
        setLoading(false);
        if (resp.error) {
            setErrMsg(resp.error.message);
            return;
        }
        navigate(FORGOT_PASSWORD_RESET, {
            state: {
                email: values.email
            },
        })
    };

    return (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Container>
                <div className={"findYourCaddie_logoContainer"}>
                    <HandicaddieLogo size={'lg'}/>
                </div>

                <div>
                    <span className={"heading"}>Forgot Password</span>
                </div>

                <div>
                    <Formik
                        validationSchema={schema}
                        onSubmit={submitForm}
                        initialValues={{
                            email: "",
                            password: "",
                        }}
                    >
                        {({
                              handleSubmit,
                              handleChange,
                              handleBlur,
                              values,
                              touched,
                              isValid,
                              errors,
                          }) => (
                            <Form
                                noValidate
                                onSubmit={handleSubmit}
                            >
                                <Row>
                                    <Col>
                                        <Form.Label column={'lg'} className={"onboarding_labelWithExplanation"}>Email</Form.Label>
                                        <span className={"onboarding_explanation"}>
                                            Please enter your email address so we can send you a confirmation code.
                                        </span>
                                        <Form.Group controlId="detailsForm.Email" style={{ marginTop: '0.25em' }}>
                                            <Form.Control
                                                required
                                                className="onboarding_input"
                                                type="email"
                                                name="email"
                                                placeholder="Email address"
                                                value={values.email}
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                            />
                                            {touched.email && errors.email && (
                                                <Alert variant={"danger"}>
                                                    {errors.email}
                                                </Alert>
                                            )}
                                        </Form.Group>
                                    </Col>
                                </Row>

                                {errMsg && <ErrorText>{errMsg}</ErrorText>}

                                {!loading &&
                                    <Button type="submit" disabled={loading} className={"forgotEmailConfirm_submitBtn"}>
                                    CONFIRM EMAIL
                                </Button>}
                                {loading && <Button disabled={loading} onClick={() => {}} className={"forgotEmailConfirm_submitBtn"}>
                                    <Spinner animation={"border"}/>
                                </Button>}
                            </Form>
                        )}
                    </Formik>
                </div>
            </Container>
        </div>
    )
}

export default ForgotPasswordEmailConfirmation;